(function(g,f){if(typeof exports=="object"&&typeof module<"u"){module.exports=f()}else if("function"==typeof define && define.amd){define("sharedworker",f)}else {g["sharedworker"]=f()}}(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : this,function(){var exports={};var __exports=exports;var module={exports};
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/ponyfill.ts
var ponyfill_exports = {};
__export(ponyfill_exports, {
  SharedWorkerPonyfill: () => SharedWorkerPonyfill,
  default: () => ponyfill_default
});
module.exports = __toCommonJS(ponyfill_exports);

// src/constants.ts
var SharedWorkerSupported = "SharedWorker" in globalThis;

// src/ponyfill.ts
var SharedWorkerPonyfill = class {
  constructor(worker) {
    /**
     * The actual worker that is used, depending on browser support it can be either a `SharedWorker` or a normal `Worker`.
     */
    __publicField(this, "ActualWorker");
    this.ActualWorker = worker;
  }
  /**
   * An EventListener called when MessageEvent of type message is fired on the port—that is, when the port receives a message.
   */
  get onmessage() {
    if (SharedWorkerSupported) {
      return this.ActualWorker?.port.onmessage;
    } else {
      return this.ActualWorker.onmessage;
    }
  }
  set onmessage(value) {
    if (SharedWorkerSupported) {
      this.ActualWorker.port.onmessage = value;
    } else {
      this.ActualWorker.onmessage = value;
    }
  }
  /**
   * An EventListener called when a MessageEvent of type MessageError is fired—that is, when it receives a message that cannot be deserialized.
   */
  get onmessageerror() {
    if (SharedWorkerSupported) {
      return this.ActualWorker?.port.onmessageerror;
    } else {
      return this.ActualWorker.onmessageerror;
    }
  }
  set onmessageerror(value) {
    if (SharedWorkerSupported) {
      this.ActualWorker.port.onmessageerror = value;
    } else {
      this.ActualWorker.onmessageerror = value;
    }
  }
  /**
   * Starts the sending of messages queued on the port (only needed when using EventTarget.addEventListener; it is implied when using MessagePort.onmessage.)
   */
  start() {
    if (SharedWorkerSupported) {
      return this.ActualWorker?.port.start();
    }
  }
  /**
   * Clones message and transmits it to worker's global environment. transfer can be passed as a list of objects that are to be transferred rather than cloned.
   */
  postMessage(message, transfer) {
    if (SharedWorkerSupported) {
      return this.ActualWorker?.port.postMessage(message, transfer);
    } else {
      return this.ActualWorker.postMessage(message, transfer);
    }
  }
  /**
   * Immediately terminates the worker. This does not let worker finish its operations; it is halted at once. ServiceWorker instances do not support this method.
   */
  terminate() {
    if (SharedWorkerSupported) {
      return this.ActualWorker?.port.close();
    } else {
      return this.ActualWorker.terminate();
    }
  }
  /**
   * Disconnects the port, so it is no longer active.
   */
  close() {
    return this.terminate();
  }
  /**
   * Returns a MessagePort object used to communicate with and control the shared worker.
   */
  get port() {
    return SharedWorkerSupported ? this.ActualWorker.port : this.ActualWorker;
  }
  /**
   * Is an EventListener that is called whenever an ErrorEvent of type error event occurs.
   */
  get onerror() {
    return this.ActualWorker.onerror;
  }
  set onerror(value) {
    this.ActualWorker.onerror = value;
  }
  addEventListener(type, listener, options) {
    if (SharedWorkerSupported && type !== "error") {
      return this.ActualWorker?.port.addEventListener(type, listener, options);
    } else {
      return this.ActualWorker.addEventListener(type, listener, options);
    }
  }
  removeEventListener(type, listener, options) {
    if (SharedWorkerSupported && type !== "error") {
      return this.ActualWorker?.port.removeEventListener(type, listener, options);
    } else {
      return this.ActualWorker.removeEventListener(type, listener, options);
    }
  }
  /**
   * Dispatches an event to this EventTarget.
   */
  dispatchEvent(event) {
    return this.ActualWorker.dispatchEvent(event);
  }
};
var ponyfill_default = SharedWorkerPonyfill;

if(__exports != exports)module.exports = exports;return module.exports}));
